import Resources from './resources';

export const getServiceUrl = async ({ urlPath }) => {
    const authToken = Resources.env.authToken;
    const curriculumManagerGateway = await Resources.getConfigurationItem('CurriculumManagerGatewayUrl');
    return `${curriculumManagerGateway}${urlPath}?authToken=${authToken}`;
};

export function makeFormDataRequest({ method, url, params }) {
    url = url.replace(/^https?:/, '');
    return new Promise((resolve) => {
        // eslint-disable-next-line no-undef
        const xhr = new XMLHttpRequest();

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                resolve(xhr);
            }
        };

        xhr.open(method, url);
        xhr.send(params);
    });
}

export const objectToFormData = ({ fileObject }) => {
    // eslint-disable-next-line no-undef
    const updatedFormData = new FormData();
    updatedFormData.append('file', fileObject);

    return updatedFormData;
};

export const API_URLS = {
    GET_SECTION_FILE: ({ sectionId }) =>
        `api/files/sections/${sectionId}/file`,
    UPLOAD_SECTION_FILE: ({ sectionId }) =>
        `api/files/sections/${sectionId}`,
    GET_PUBLICATION_FILES: ({ productId, publicationId }) =>
        `api/files/products/${productId}/publications/${publicationId}/file`,
    UPLOAD_PUBLICATION_FILE: ({ productId, publicationId }) =>
        `api/files/products/${productId}/publications/${publicationId}`
};



// WEBPACK FOOTER //
// ./app/helpers/api-utils.js